import * as E from "@numi/engine";
import { useApp, set, stickersOwned } from "../store.ts";
import { freeTrickFor } from "./TrickPeek.tsx";
import { Card, Numi } from "../ui.tsx";

/** What a child sees when the family's free week has ended and no plan is active. */
export function TrialOver({ openGrown }: { openGrown: () => void }) {
  const s = useApp();
  return <main><Card className="done">
    <Numi size={120} mood="fly" />
    <h2>Great week, {s.child?.name}!</h2>
    <p style={{ fontSize: "1.2rem", margin: 0, maxWidth: "32em" }}>Your free week with Numi is over. Ask a grown-up to pick a plan so we can keep flying through maths together. Your stars and stickers are safe.</p>
    <p className="note" style={{ fontSize: "1.05rem" }}>{s.totalStars} star{s.totalStars === 1 ? "" : "s"} · {Math.min(stickersOwned(), E.STICKERS.length)} sticker{stickersOwned() === 1 ? "" : "s"} saved</p>
    <button className="btn yellow big" onClick={openGrown}>Grown-ups: see plans</button>
    <button className="btn soft" onClick={() => set({ trickPeek: freeTrickFor(s.child?.grade ?? 3) })}>Try a free Vedic Maths trick</button>
    <p className="note">Grown-ups: press the button, or the gear at the top.</p>
  </Card></main>;
}
